const NavMenu = ({ onMenuSelect, activeRoute = "/" }) => {
  const menuItems = [
    {
      label: "Dashboard",
      action: "/",
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
    },
    {
      label: "Leads",
      action: "/leads",
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      ),
    },
  ];

  const getIsActive = (path) => {
    if (path === "/") {
      return activeRoute === "/";
    }
    return activeRoute.includes(path.slice(1));
  };

  return (
    <nav className="flex items-center">
      <ul className="flex items-center space-x-2">
        {menuItems.map((item) => (
          <li key={item.action}>
            <button
              data-attr={`nav-${item.label.toLowerCase()}`}
              onClick={() => onMenuSelect(item.action)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                getIsActive(item.action)
                  ? "bg-white/20 text-white backdrop-blur-sm"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
              aria-current={getIsActive(item.action) ? "page" : undefined}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavMenu;
